import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import SubscribeModal from '../components/blog/SubscribeModal';

const SubscribeModalContext = createContext({
  openSubscribe: () => {},
  closeSubscribe: () => {},
});

export function SubscribeModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openSubscribe = useCallback(() => setIsOpen(true), []);
  const closeSubscribe = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ openSubscribe, closeSubscribe, isOpen }),
    [openSubscribe, closeSubscribe, isOpen]
  );

  return (
    <SubscribeModalContext.Provider value={value}>
      {children}
      <SubscribeModal isOpen={isOpen} onClose={closeSubscribe} />
    </SubscribeModalContext.Provider>
  );
}

export function useSubscribeModal() {
  return useContext(SubscribeModalContext);
}
